export default function SocialMedia({ company }) {


    const gtag_report_conversion = (url) => {
        const callback = () => {
            if (typeof url !== 'undefined') {
                // Redirect
                //window.location = url;
                //Abre nova aba
                window.open(url, '_blank', 'noopener,noreferrer');
            }
        };

        if (window.gtag) {
            window.gtag('event', 'conversion', {
                'send_to': 'AW-17775759901/tz93COboqN0bEJ2kkpxC',
                'event_callback': callback
            });
        }

        return false;
    };

    const handleClick = (e, phoneNumber) => {
        e.preventDefault();
        const message = company.whatsappDefaultMessage
            ? company.whatsappDefaultMessage
            : "Olá, gostaria de tirar algumas dúvidas com um consultor. Alguém disponível para me atender agora?";
        const url = `https://wa.me/55${phoneNumber}?text=${encodeURIComponent(message)}`;
        gtag_report_conversion(url);
    };

    const defaultMessage = company.whatsappDefaultMessage
        ? company.whatsappDefaultMessage
        : "Olá, gostaria de tirar algumas dúvidas com um consultor. Alguém disponível para me atender agora?";

    return (
        <section className="box">
            <div className="share">
                <a
                    href={`https://api.whatsapp.com/send?phone=55${company.whatsapp}&text=${encodeURIComponent(defaultMessage)}`}
                    onClick={(e) => handleClick(e, company.whatsapp)}
                    target="_blank"
                    className="modal-whats"
                    rel="noreferrer"
                    aria-label='Fale conosco pelo whatsapp'
                >
                    <div>
                        <i className="fab fa-whatsapp"></i>
                    </div>
                </a>
                {company.whatsapp2 && (
                    <a
                        href={`https://api.whatsapp.com/send?phone=55${company.whatsapp2}&text=${encodeURIComponent(defaultMessage)}`}
                        onClick={(e) => handleClick(e, company.whatsapp2)}
                        target="_blank"
                        className="modal-whats2"
                        rel="noreferrer"
                        aria-label='Fale conosco pelo whatsapp 2'
                    >
                        <div>
                            <i className="fab fa-whatsapp"></i>
                        </div>
                    </a>
                )}
                {
                    company.facebook
                        ? <a href={company.facebook} target="_blank" className="modal-facebook" rel="noreferrer" aria-label='Acesse nosso facebook'>
                            <div>
                                <i className="fab fa-facebook-f"></i>
                            </div>
                        </a>
                        : null
                }
                {
                    company.instagram
                        ? <a href={company.instagram} target="_blank" className="modal-instagram" rel="noreferrer" aria-label='Acesso nosso instagram'>
                            <div>
                                <i className="fab fa-instagram"></i>
                            </div>
                        </a>
                        : null
                }
                {
                    company.youtube
                        ? <a href={company.youtube} target="_blank" className="modal-youtube" rel="noreferrer" aria-label='Acesse nosso youtube'>
                            <div>
                                <i className="fab fa-youtube"></i>
                            </div>
                        </a>
                        : null
                }
                {
                    company.tiktok
                        ? <a href={company.tiktok} target="_blank" className="modal-tiktok" rel="noreferrer" aria-label='Acesse nosso tiktok'>
                            <div>
                                <i className="fab fa-tiktok"></i>
                            </div>
                        </a>
                        : null
                }
            </div>
        </section>
    )
}